/* eslint-disable */

export enum PriceMode {
  NORMAL = 1,
  SHARE = 2,
  RENTAL = 3,
  QUICK_COMMERCE = 4,
  DELIVERY = 5,
  PICKUP = 6,
  ON_SITE_SERVICE = 8,
  SERVICE_AT_HOME = 9,
  ONLINE_SERVICE = 10,
  TAXI_METER = 101,
  TOWING = 102
}

export enum BookingCreatedBy {
  CUSTOMER = 2,
  DRIVER = 3,
  DISPATCHER = 5,
  CORPORATE = 6,
  ADMIN = 1,
  PARTNER = 4
}

export const CityBookingCreatedByString: Record<BookingCreatedBy, string> = {
  [BookingCreatedBy.ADMIN]: "label-title.hub",
  [BookingCreatedBy.CUSTOMER]: "label-title.customer",
  [BookingCreatedBy.DRIVER]: "label-title.driver",
  [BookingCreatedBy.PARTNER]: "label-title.partner",
  [BookingCreatedBy.DISPATCHER]: "label-title.dispatcher",
  [BookingCreatedBy.CORPORATE]: "label-title.corporate"
};

export const PriceModeString: Record<any, string> = {
  [PriceMode.NORMAL]: "label-title.normal",
  [PriceMode.SHARE]: "label-title.ride-share",
  [PriceMode.RENTAL]: "label-title.rental",
  [PriceMode.QUICK_COMMERCE]: "label-title.quick-commerce",
  [PriceMode.DELIVERY]: "label-title.delivery",
  [PriceMode.PICKUP]: "label-title.pickup",
  [PriceMode.ON_SITE_SERVICE]: "label-title.on-site-service",
  [PriceMode.SERVICE_AT_HOME]: "label-title.service-at-home",
  [PriceMode.ONLINE_SERVICE]: "label-title.online-service",
  [PriceMode.TAXI_METER]: "label-title.taxi-meter",
  [PriceMode.TOWING]: "label-title.towing"
};

export enum BookingType {
  NORMAL = 1,
  SHARE = 2,
  RENTAL = 3,
  QUICK_COMMERCE = 4,
  DELIVERY = 5,
  PICKUP = 6,
  ON_SITE_SERVICE = 8,
  SERVICE_AT_HOME = 9,
  ONLINE_SERVICE = 10,
  NOW = 11,
  SCHEDULE = 12,
  BIDDING = 13,
  MULTIPLE_LOCATION = 14,
  FIX_FARE = 15,
  CITY_TO_CITY = 16,
  ZONE = 17,
  AIRPORT = 18,
  DESTINATION_LATER = 19,
  RED_ZONE = 22,
  OUTSIDE_BOUNDARY = 24,
  IS_ALWAYS_FIX_FARE = 26,
  PICKUP_FROM_HOME = 27,
  DROP_AT_HOME = 28,
  TAXI_METER = 101,
  TOWING = 102
}

export enum BookingStatus {
  REQUESTED = 1,
  ASSIGNED = 10,
  NO_DRIVER_FOUND = 11,
  NOT_ANSWERED = 12,
  REJECTED = 13,
  MERCHANT_ACCEPTED = 14,
  MERCHANT_PREPARING = 141,
  MERCHANT_COMPLETED = 142,
  PICKER_ASSIGNED = 15,
  NO_PICKER_FOUND = 16,
  PICKER_NOT_ANSWERED = 17,
  PICKER_REJECTED = 18,
  PICKER_ACCEPTED = 19,
  ACCEPTED = 20,
  BID_ACCEPTED = 21,
  BID_REJECTED = 22,
  BID_NOT_ANSWERED = 23,
  PICKER_COMPLETED = 24,
  PICKER_ITEM_PICKED = 25,
  IN_ROUTE = 30,
  ARRIVED_AT_PICKUP = 40,
  PICKED = 41,
  DROPPED = 42,
  STARTED = 50,
  SERVICE_STARTED = 51,
  SERVICE_PAUSE = 52,
  SERVICE_COMPLETED = 55,
  ARRIVED_AT_STOP = 60,
  ARRIVED_NEAR_DESTINATION = 65,
  ARRIVED_AT_DESTINATION = 70,
  COMPLETED = 80,
  CUSTOMER_INVOICE_SUBMITTED = 81,
  DRIVER_INVOICE_SUBMITTED = 82,
  CUSTOMER_RATED = 83,
  DRIVER_RATED = 84,
  CUSTOMER_MERCHANT_RATED = 85,
  DRIVER_MERCHANT_RATED = 86,
  MERCHANT_CUSTOMER_RATED = 87,
  MERCHANT_DRIVER_RATED = 88,
  CANCELLED = 90,
  MERCHANT_REJECTED = 91
}

export const BookingStatusStrings: Record<BookingStatus, string> = {
  [BookingStatus.REQUESTED]: "label-title.requested",
  [BookingStatus.ASSIGNED]: "label-title.assigned",
  [BookingStatus.NO_DRIVER_FOUND]: "label-title.no-driver-found",
  [BookingStatus.NOT_ANSWERED]: "label-title.not-answered",
  [BookingStatus.REJECTED]: "label-title.rejected",
  [BookingStatus.ACCEPTED]: "label-title.accepted",
  [BookingStatus.IN_ROUTE]: "label-title.in-route",
  [BookingStatus.ARRIVED_AT_PICKUP]: "label-title.arrived-at-pickup",
  [BookingStatus.STARTED]: "label-title.started",
  [BookingStatus.SERVICE_STARTED]: "label-title.service-started",
  [BookingStatus.SERVICE_PAUSE]: "label-title.service-paused",
  [BookingStatus.SERVICE_COMPLETED]: "label-title.service-completed",
  [BookingStatus.ARRIVED_AT_STOP]: "label-title.arrived-at-stop",
  [BookingStatus.ARRIVED_NEAR_DESTINATION]: "label-title.arrived-at-near-destination",
  [BookingStatus.ARRIVED_AT_DESTINATION]: "label-title.completed",
  [BookingStatus.CANCELLED]: "label-title.cancelled",
  [BookingStatus.MERCHANT_ACCEPTED]: "label-title.merchant-accepted",
  [BookingStatus.PICKER_ASSIGNED]: "label-title.picker-assigned",
  [BookingStatus.NO_PICKER_FOUND]: "label-title.no-picker-found",
  [BookingStatus.PICKER_NOT_ANSWERED]: "label-title.picker-not-answered",
  [BookingStatus.PICKER_REJECTED]: "label-title.picker-rejected",
  [BookingStatus.PICKER_ACCEPTED]: "label-title.picker-accepted",
  [BookingStatus.BID_ACCEPTED]: "label-title.bid-accepted",
  [BookingStatus.BID_REJECTED]: "label-title.bid-rejected",
  [BookingStatus.BID_NOT_ANSWERED]: "label-title.bid-not-answered",
  [BookingStatus.PICKER_COMPLETED]: "label-title.picker-completed",
  [BookingStatus.PICKER_ITEM_PICKED]: "label-title.picker-item-picked",
  [BookingStatus.PICKED]: "label-title.picked",
  [BookingStatus.DROPPED]: "label-title.dropped",
  [BookingStatus.CUSTOMER_INVOICE_SUBMITTED]: "label-title.customer-invoice-submitted",
  [BookingStatus.DRIVER_INVOICE_SUBMITTED]: "label-title.driver-invoice-submitted",
  [BookingStatus.CUSTOMER_RATED]: "label-title.customer-rated",
  [BookingStatus.DRIVER_RATED]: "label-title.driver-rated",
  [BookingStatus.MERCHANT_REJECTED]: "label-title.merchant-rejected",
  [BookingStatus.COMPLETED]: "label-title.completed",
  [BookingStatus.CUSTOMER_MERCHANT_RATED]: "label-title.merchant-rated-by-customer",
  [BookingStatus.DRIVER_MERCHANT_RATED]: "label-title.merchant-rated-by-driver",
  [BookingStatus.MERCHANT_CUSTOMER_RATED]: "label-title.customer-rated-by-merchant",
  [BookingStatus.MERCHANT_DRIVER_RATED]: "label-title.driver-rated-by-merchant",
  [BookingStatus.MERCHANT_PREPARING]: "label-title.merchant-preparing",
  [BookingStatus.MERCHANT_COMPLETED]: "label-title.merchant-completed"
};

export const BookingTypeString: Record<any, string> = {
  [BookingType.NORMAL]: "label-title.normal",
  [BookingType.SHARE]: "label-title.ride-share",
  [BookingType.RENTAL]: "label-title.rental",
  [BookingType.NOW]: "label-title.now",
  [BookingType.SCHEDULE]: "label-title.schedule",
  [BookingType.BIDDING]: "label-title.bidding",
  [BookingType.MULTIPLE_LOCATION]: "label-title.multiple-location",
  [BookingType.FIX_FARE]: "label-title.fix-fare",
  [BookingType.CITY_TO_CITY]: "label-title.city-to-city",
  [BookingType.ZONE]: "label-title.zone-to-zone-fixed-price",
  [BookingType.AIRPORT]: "label-title.airport",
  [BookingType.DESTINATION_LATER]: "label-title.destination-later",
  [BookingType.RED_ZONE]: "label-title.red-zone",
  [BookingType.OUTSIDE_BOUNDARY]: "label-title.outside-boundry",
  [BookingType.IS_ALWAYS_FIX_FARE]: "label-title.always-fix-fare",
  [BookingType.PICKUP]: "label-title.pickup",
  [BookingType.QUICK_COMMERCE]: "label-title.quick-commerce",
  [BookingType.DELIVERY]: "label-title.delivery",
  [BookingType.ON_SITE_SERVICE]: "label-title.on-site-service",
  [BookingType.SERVICE_AT_HOME]: "label-title.service-at-home",
  [BookingType.ONLINE_SERVICE]: "label-title.online-service",
  [BookingType.PICKUP_FROM_HOME]: "label-title.pickup-from-home",
  [BookingType.DROP_AT_HOME]: "label-title.drop-at-home",
  [BookingType.TAXI_METER]: "label-title.taxi-meter",
  [BookingType.TOWING]: "label-title.towing"
};

export const TagColorTypeString: Record<any, string> = {
  [BookingType.SHARE]: "label-title.ride-share",
  [BookingType.RENTAL]: "label-title.rental",
  [BookingType.SCHEDULE]: "label-title.schedule",
  [BookingType.BIDDING]: "label-title.bidding",
  [BookingType.FIX_FARE]: "label-title.fix-fare-tag-color",
  [BookingType.CITY_TO_CITY]: "label-title.city-to-city-tag-color",
  [BookingType.ZONE]: "label-title.zone-tag-color",
  [BookingType.AIRPORT]: "label-title.airport-tag-color",
  [BookingType.QUICK_COMMERCE]: "label-title.quick-commerce",
  [BookingType.DELIVERY]: "label-title.delivery",
  [BookingType.PICKUP]: "label-title.pickup",
  [BookingType.ON_SITE_SERVICE]: "label-title.on-site-service",
  [BookingType.SERVICE_AT_HOME]: "label-title.service-at-home",
  [BookingType.ONLINE_SERVICE]: "label-title.online-service",
  [BookingType.PICKUP_FROM_HOME]: "label-title.pickup-from-home",
  [BookingType.DROP_AT_HOME]: "label-title.drop-at-home"
};

export const BookingHistoryFilterBookingType = [
  { key: BookingType[BookingType.BIDDING], string: BookingTypeString[BookingType.BIDDING] },
  { key: BookingType[BookingType.MULTIPLE_LOCATION], string: BookingTypeString[BookingType.MULTIPLE_LOCATION] },
  { key: BookingType[BookingType.FIX_FARE], string: BookingTypeString[BookingType.FIX_FARE] },
  { key: BookingType[BookingType.AIRPORT], string: BookingTypeString[BookingType.AIRPORT] },
  { key: BookingType[BookingType.CITY_TO_CITY], string: BookingTypeString[BookingType.CITY_TO_CITY] },
  { key: BookingType[BookingType.ZONE], string: BookingTypeString[BookingType.ZONE] },
  { key: BookingType[BookingType.DESTINATION_LATER], string: BookingTypeString[BookingType.DESTINATION_LATER] },
  { key: BookingType[BookingType.RED_ZONE], string: BookingTypeString[BookingType.RED_ZONE] },
  { key: BookingType[BookingType.OUTSIDE_BOUNDARY], string: BookingTypeString[BookingType.OUTSIDE_BOUNDARY] }
];

export const BookingHistoryBookingTypeArray: { key: PriceMode; string: string }[] = [];

export const BookingStatusKeyStringArray: { key: BookingStatus; string: string }[] = [];

Object.values(PriceMode).forEach((enumValue) => {
  if (typeof enumValue === "number") {
    BookingHistoryBookingTypeArray.push({
      key: enumValue as PriceMode,
      string: PriceModeString[enumValue as PriceMode]
    });
  }
});

Object.values(BookingStatus).forEach((enumValue) => {
  if (typeof enumValue === "number") {
    BookingStatusKeyStringArray.push({
      key: enumValue as BookingStatus,
      string: BookingStatusStrings[enumValue as BookingStatus]
    });
  }
});

export enum AllBookingStatus {
  REQUESTED = 1,
  ASSIGNED = 10,
  NO_DRIVER_FOUND = 11,
  NOT_ANSWERED = 12,
  REJECTED = 13,
  ACCEPTED = 20,
  BID_ACCEPTED = 21,
  BID_REJECTED = 22,
  BID_NOT_ANSWERED = 23,
  IN_ROUTE = 30,
  ARRIVED_AT_PICKUP = 40,
  STARTED = 50,
  ARRIVED_AT_STOP = 60,
  ARRIVED_AT_DESTINATION = 70,
  COMPLETED = 80,
  CUSTOMER_INVOICE_SUBMITTED = 81,
  DRIVER_INVOICE_SUBMITTED = 82,
  CUSTOMER_RATED = 83,
  DRIVER_RATED = 84,
  CANCELLED = 90
}

export const AllBookingStatusStrings: Record<any, string> = {
  [AllBookingStatus.REQUESTED]: "label-title.requested",
  [AllBookingStatus.ASSIGNED]: "label-title.assigned",
  [AllBookingStatus.NO_DRIVER_FOUND]: "label-title.no-driver-found",
  [AllBookingStatus.NOT_ANSWERED]: "label-title.not-answered",
  [AllBookingStatus.REJECTED]: "label-title.rejected",
  [AllBookingStatus.ACCEPTED]: "label-title.accepted",
  [AllBookingStatus.IN_ROUTE]: "label-title.in-route",
  [AllBookingStatus.ARRIVED_AT_PICKUP]: "label-title.arrived-at-pickup",
  [AllBookingStatus.STARTED]: "label-title.started",
  [AllBookingStatus.ARRIVED_AT_STOP]: "label-title.arrived-at-stop",
  [AllBookingStatus.ARRIVED_AT_DESTINATION]: "label-title.arrived-at-destination",
  [AllBookingStatus.COMPLETED]: "label-title.completed",
  [AllBookingStatus.CANCELLED]: "label-title.cancelled",
  [AllBookingStatus.BID_ACCEPTED]: "label-title.bid-accepted",
  [AllBookingStatus.BID_REJECTED]: "label-title.bid-rejected",
  [AllBookingStatus.BID_NOT_ANSWERED]: "label-title.bid-not-answered",
  [AllBookingStatus.CUSTOMER_INVOICE_SUBMITTED]: "label-title.customer-invoice-submitted",
  [AllBookingStatus.DRIVER_INVOICE_SUBMITTED]: "label-title.driver-invoice-submitted",
  [AllBookingStatus.CUSTOMER_RATED]: "label-title.customer-rated",
  [AllBookingStatus.DRIVER_RATED]: "label-title.driver-rated"
};

export const DispatcherBookingType = [
  { key: BookingType[BookingType.NORMAL], string: BookingTypeString[BookingType.NORMAL], isActive: false },
  { key: BookingType[BookingType.SHARE], string: BookingTypeString[BookingType.SHARE], isActive: false },
  { key: BookingType[BookingType.RENTAL], string: BookingTypeString[BookingType.RENTAL], isActive: false },
  { key: BookingType[BookingType.TAXI_METER], string: BookingTypeString[BookingType.TAXI_METER], isActive: false },
  { key: BookingType[BookingType.TOWING], string: BookingTypeString[BookingType.TOWING], isActive: false },
  // { key: BookingType[BookingType.OPEN_BOOKING], string: BookingTypeString[BookingType.OPEN_BOOKING], isActive: false }
];

export const DispatcherBookingTypeTime = [
  { key: BookingType[BookingType.NOW], string: BookingTypeString[BookingType.NOW] },
  { key: BookingType[BookingType.SCHEDULE], string: BookingTypeString[BookingType.SCHEDULE] }
];

export enum DispatcherBookingStatusEnum {
  ACTIVE = 1,
  ASSIGNED = 2,
  UNASSIGNED = 3
}

export enum bookingDriverAssignEnum {
  NEAREST_DRIVER = 0,
  MANUALLY = 1
}

export enum bookingFareType {
  ESTIMATEFARE = 0,
  FIXFARE = 1
}

export const maxScheduleBookingDaysFromToday: number = 15;

export enum BookingSetting {
  ShowDriverEstimation = 1,
  ShowNearestDriver = 2,
  ShowFareEstimation = 3,
  ShowFareEstimationInDetail = 4,
  AllowPromocode = 5,
  AllowCorporateBooking = 6,
  CorporateBookingConfirmationRequired = 7, // Direct mapping for array of ObjectIds
  AllowNoOfSeatSelection = 8,
  Tip = 9,
  AllowRideForOther = 10,
  CheckDriverLocationForStartBooking = 11,
  SkipComingForPickupStatus = 12,
  EditFareEstimate = 13,
  ShowAgencySelection = 16
}

export const CustomerCityBookingTypeEnum = [
  BookingSetting[BookingSetting.ShowDriverEstimation],
  BookingSetting[BookingSetting.ShowNearestDriver],
  BookingSetting[BookingSetting.ShowFareEstimation],
  BookingSetting[BookingSetting.ShowFareEstimationInDetail],
  BookingSetting[BookingSetting.AllowPromocode],
  BookingSetting[BookingSetting.AllowCorporateBooking],
  BookingSetting[BookingSetting.Tip],
  BookingSetting[BookingSetting.AllowRideForOther],
  BookingSetting[BookingSetting.CheckDriverLocationForStartBooking],
  BookingSetting[BookingSetting.SkipComingForPickupStatus],
  BookingSetting[BookingSetting.AllowNoOfSeatSelection]
];

export enum BusinessType {
  TAXI = 1,
  QUICK_COMMERCE = 2,
  DELIVERY = 3,
  SERVICE = 4,
  TAXI_METER = 6,
  TOWING = 7
}

export const BusinessTypeString: Record<BusinessType, string> = {
  [BusinessType.TAXI]: "label-title.taxi",
  [BusinessType.QUICK_COMMERCE]: "label-title.quick-commerce",
  [BusinessType.DELIVERY]: "label-title.delivery",
  [BusinessType.SERVICE]: "label-title.service",
  [BusinessType.TAXI_METER]: "label-title.taxi-meter",
  [BusinessType.TOWING]: "label-title.towing"
};

export const BusinessTypeArray: { key: BusinessType; string: string }[] = [];

Object.values(BusinessType).forEach((enumValue) => {
  if (typeof enumValue === "number") {
    BusinessTypeArray.push({
      key: enumValue as BusinessType,
      string: BusinessTypeString[enumValue as BusinessType]
    });
  }
});

export enum TitleStatus {
  ASSIGN_PICKER,
  START,
  COMING,
  ARRIVED,
  COMPLETE,
  CANCEL,
  REASSIGN,
  ASSIGN_DELIVERYMAN,
  ASSIGN_MERCHANT,
  MERCHANT_ACCEPT,
  START_PREPARING,
  ORDER_READY,
  ACCEPT_REJECT,
  PICKER_ACCEPT_REJECT
}

export const TitleStatusString: Record<any, string> = {
  [TitleStatus.ASSIGN_PICKER]: "label-title.assign-picker",
  [TitleStatus.START]: "label-title.start",
  [TitleStatus.COMING]: "label-title.coming",
  [TitleStatus.ARRIVED]: "label-title.arrived",
  [TitleStatus.COMPLETE]: "label-title.complete",
  [TitleStatus.CANCEL]: "label-title.cancel",
  [TitleStatus.REASSIGN]: "label-title.reassign",
  [TitleStatus.ASSIGN_DELIVERYMAN]: "label-title.assign-deliveryman",
  [TitleStatus.ASSIGN_MERCHANT]: "label-title.assign-merchant",
  [TitleStatus.MERCHANT_ACCEPT]: "label-title.merchant-accept",
  [TitleStatus.START_PREPARING]: "label-title.start-preparing",
  [TitleStatus.ORDER_READY]: "label-title.order-ready",
  [TitleStatus.ACCEPT_REJECT]: "label-title.accept-reject",
  [TitleStatus.PICKER_ACCEPT_REJECT]: "label-title.picker-accept-reject"
};
